import { render, staticRenderFns } from "./IndexDoCoop.vue?vue&type=template&id=b491fb8a&scoped=true"
import script from "./IndexDoCoop.vue?vue&type=script&lang=js"
export * from "./IndexDoCoop.vue?vue&type=script&lang=js"
import style0 from "./IndexDoCoop.vue?vue&type=style&index=0&id=b491fb8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b491fb8a",
  null
  
)

export default component.exports